import { computed, Signal } from "@angular/core";
import { StoreSection } from "../../storage/data-store/model/master-data/store-section";
import { StoreTrial } from "../../storage/data-store/model/master-data/store-trial";
import { StoreAnimalWeighing } from "../../storage/data-store/model/registrations/store-animal-weighing";
import { StoreBatchWeighing } from "../../storage/data-store/model/registrations/store-batch-weighing";
import { StringUuid } from "../../domain/model/uuid/string-uuid";
import { getBatchWeighingsForTrial } from "../../functions/data-store/data-store-batch-weighing.function";
import { recordForEach, recordSet } from "../../functions/record.function";
import { StoreBatch } from "../../storage/data-store/model/master-data/store-batch";
import { SectionIdTrialIdUuid } from "../section-id-trial-id-uuid";
import { SectionOverviewViewModel } from "../section-overview/section-overview.viewmodel";
import { mapTrialToSectionOverviewViewModels } from "../../functions/data-store/data-store-to-viewmodels.function";


export const sectionOverviewViewModelConst = (

  sections: Signal<Record<string, StoreSection>>,
  trials: Signal<Record<string, StoreTrial>>,
  batches: Signal<Record<string, StoreBatch>>,
  batchWeighings: Signal<Record<string, StoreBatchWeighing>>,
  animalWeighings: Signal<Record<string, StoreAnimalWeighing>>
) => {
  return computed(() => {
    const retRecord = {} as Record<string, SectionOverviewViewModel>;
    recordForEach<StoreTrial>(trials(), (trial) => {
      const bwForTrial = getBatchWeighingsForTrial(trial.id.toString(), batchWeighings);

      const sectionWeighingViewModels = mapTrialToSectionOverviewViewModels(
        sections,
        trial,
        batches,
        bwForTrial,
        animalWeighings
      );
        
      sectionWeighingViewModels.forEach((sw) => {
        const concatKey = new SectionIdTrialIdUuid(
          sw.section.id,
          new StringUuid(trial.id)
        ).toConcatedKey();

        recordSet(retRecord, concatKey, sw);
      });
    });
    return retRecord as Readonly<Record<string, SectionOverviewViewModel>>;
  });
};
